export const HOTEL_NAME = process.env.REACT_APP_HOTEL_NAME || '';

export const HOTEL_LEGAL_NAME = process.env.REACT_APP_HOTEL_LEGAL_NAME || HOTEL_NAME;

export const HOTEL_SHORT_NAME = process.env.REACT_APP_HOTEL_SHORT_NAME || HOTEL_NAME;

export const HOTEL_TAGLINE = process.env.REACT_APP_HOTEL_TAGLINE || '';

export const HOTEL_ADDRESS = process.env.REACT_APP_HOTEL_ADDRESS || '';

export const HOTEL_LOCATION_URL = process.env.REACT_APP_HOTEL_LOCATION_URL || '#';

export const HOTEL_PHONE = process.env.REACT_APP_HOTEL_PHONE || '';

export const HOTEL_INVOICE_PHONE =
  process.env.REACT_APP_HOTEL_INVOICE_PHONE || HOTEL_PHONE;

export const HOTEL_EMAIL = process.env.REACT_APP_HOTEL_EMAIL || '';

export const HOTEL_COPYRIGHT_LOCATION =
  process.env.REACT_APP_HOTEL_COPYRIGHT_LOCATION || '';

export const HOTEL_PAYMENT_NAME =
  process.env.REACT_APP_HOTEL_PAYMENT_NAME || HOTEL_NAME.toUpperCase();

export const HOTEL_ABOUT_TITLE =
  process.env.REACT_APP_HOTEL_ABOUT_TITLE || `About ${HOTEL_NAME}`;

export const HOTEL_ABOUT_TAGLINE =
  process.env.REACT_APP_HOTEL_ABOUT_TAGLINE || HOTEL_TAGLINE;

export const HOTEL_ROOM_SUMMARY = process.env.REACT_APP_HOTEL_ROOM_SUMMARY || '';

export const HOTEL_LOCATION_LABEL =
  process.env.REACT_APP_HOTEL_LOCATION_LABEL || '';

export const HOTEL_NEARBY_LANDMARK =
  process.env.REACT_APP_HOTEL_NEARBY_LANDMARK || '';

export const HOTEL_CITY = process.env.REACT_APP_HOTEL_CITY || '';
